module.exports = __webpack_public_path__ + "img/qg_08.4641cd99.png";